const projectSettingsConnectRoutes = [
	/\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
	/\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i,
];

export default projectSettingsConnectRoutes;
